(()=>{
  'use strict';
  const { qa, toast } = window.MB || {};
  if (!qa) return;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    const id = Number(button.dataset.variantId);
    if (!id) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(window.MedLitx.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not add item');
      document.dispatchEvent(new CustomEvent('medlitx:cart:refresh', { detail: { open: true } }));
      toast('Added to cart');
    } catch (error) {
      toast(error.message || 'Could not add to cart');
    } finally {
      button.disabled = false;
      button.textContent = original;
    }
  });
})();
